import PropTypes from 'prop-types';

function MMMeatAndSeafoodInactive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <g clipPath="url(#clip0_386_11288)">
                <path
                    d="M27.7085 7.05007C27.7573 6.3277 27.8885 3.48674 25.8249 2.18181C23.7613 0.876888 17.5449 0.451999 13.5678 2.95341C9.59077 5.45483 9.97803 10.2763 12.591 12.9874C14.6003 15.0928 16.9425 16.8532 19.5235 18.198C22.5064 19.7983 25.6977 20.8024 27.2965 20.3077C28.8953 19.813 31.0525 18.4789 29.9913 15.4097C29.5273 14.3488 28.4164 13.6252 27.8372 12.4474C27.258 11.2696 27.5685 9.01584 27.7085 7.05007Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M25.9602 8.71008C26.0092 8.12523 26.66 4.85534 24.864 3.66104C23.0679 2.46675 17.6989 2.43804 14.6017 4.20291C11.5045 5.96779 11.8605 9.92127 14.2017 12.3022C16.5429 14.6832 18.4647 15.7414 20.1916 16.757C22.7672 18.2591 24.773 18.9199 26.2179 18.8012C27.5148 18.6921 29.2371 17.7472 28.3899 15.6138C28.0147 14.6777 26.9854 14.0563 26.4241 13.0567C25.8629 12.0571 25.8083 10.5125 25.9602 8.71008Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeMiterlimit="10"
                />
                <path
                    d="M22.3739 5.68413C23.7404 5.43134 24.0147 6.838 23.0306 7.12584C21.2135 7.66001 20.4253 7.72691 19.9669 7.92688C19.3864 8.17989 18.996 9.17573 22.4231 12.7319C23.8891 14.253 25.2832 15.5487 24.5857 16.1606C24.0524 16.6308 22.4731 15.1418 20.6068 13.1088C17.6005 9.82575 18.484 8.95112 17.5206 8.83901C16.5572 8.7269 14.6549 9.62318 14.325 8.48398C14.1433 7.82639 14.5907 7.60443 17.0714 6.87597C18.815 6.37906 20.5854 5.98114 22.3739 5.68413V5.68413Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M2.72224 13.4984C3.36689 13.0364 8.31358 10.6204 12.5222 12.8296C16.7307 15.0389 18.4148 17.6455 19.6191 21.5908C21.8729 20.8253 23.986 20.8032 26.1928 23.4272C24.7952 22.9838 22.5053 24.2306 21.7152 25.4432C20.7664 26.8764 21.0295 28.4966 21.9392 30.2815C19.6788 29.8167 17.004 28.4308 17.5751 25.047C15.7137 25.9506 13.6214 26.2663 11.5762 25.9523C9.53106 25.6383 7.62984 24.7095 6.12516 23.2892C1.70111 19.1834 2.72224 13.4984 2.72224 13.4984Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M9.74964 11.9843C10.6778 11.705 11.6195 11.4728 12.571 11.2883C14.1257 10.9824 16.2769 12.257 17.5838 13.4848C18.8907 14.7126 19.7447 15.6923 19.817 16.151C19.8893 16.6097 18.8371 19.1077 18.8371 19.1077C18.8371 19.1077 16.9773 15.3451 14.3066 13.8892C12.8689 13.075 11.3391 12.4355 9.74964 11.9843V11.9843Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M4.38128 21.2002C4.81452 21.1445 7.38687 21.1129 9.78682 18.473C12.1868 15.8332 11.2252 12.4642 11.2252 12.4642C11.2252 12.4642 7.40812 10.8993 2.72222 13.4982C2.04796 17.5709 4.38128 21.2002 4.38128 21.2002Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M7.57739 15.363C7.92098 15.4027 8.2317 15.1564 8.2714 14.8128C8.31111 14.4692 8.06476 14.1585 7.72118 14.1188C7.37759 14.0791 7.06687 14.3254 7.02717 14.669C6.98746 15.0126 7.23381 15.3233 7.57739 15.363Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M11.1129 16.1478C11.1129 16.1478 13.1593 17.0421 13.487 20.3731C10.3855 21.765 8.29353 19.8081 8.29353 19.8081C8.29353 19.8081 9.70357 19.466 11.1129 16.1478Z"
                    fill="#FFF9EA"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.8816 18.4215C16.5209 18.9888 15.7719 20.3197 15.0728 20.1684C15.5991 20.8323 14.9049 22.1969 13.9544 22.0871C14.0572 22.2599 14.1096 22.4581 14.1056 22.6591C14.1016 22.8602 14.0415 23.0561 13.932 23.2248C13.8224 23.3934 13.6679 23.5281 13.4858 23.6134C13.3037 23.6988 13.1014 23.7316 12.9017 23.7079"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.0731 20.4468C17.6795 20.9593 16.9634 22.345 16.0935 22.1465C16.497 22.8902 15.9345 23.9294 15.0408 23.7674"
                    stroke="#2D2D2D"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_386_11288">
                    <rect width="30" height="30" fill="white" transform="translate(0.894531 0.303711)" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default MMMeatAndSeafoodInactive;

MMMeatAndSeafoodInactive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number.isRequired,
};

MMMeatAndSeafoodInactive.defaultProps = {
    className: null,
};
